module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/img-wedding-compact-standard-06b75b82e1b5a507e2b234644746bdf4.png";